import Dexie from "dexie";

const db = new Dexie("MyPurchasesDB");

db.version(1).stores({
  purchases:
    "id, date, supplier, gross, net, vat, vatExempt, zeroRated, status, image, bank ,category",
  purchasesByDate:
    "id, gross, net, vat,vatExempt, zeroRated,status, image, bank, category",
  purchasesBySupplier:
    "id, gross, net, vat,vatExempt, zeroRated,status, image, bank, category",
});

export default db;
